module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "revision-history-revision"
  }, [_c('div', {
    staticClass: "revision-history-revision__revision-header"
  }, [_vm._v("\n    " + _vm._s(_vm.revisionText) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "revision-history-revision__footer"
  }, [_c('span', [_c('span', {
    staticClass: "revision-history-revision__audience"
  }, [_vm._v("\n            " + _vm._s(_vm.totalAudience) + "\n            ")]), _vm._v(" "), (!_vm.isCurrentRevision) ? [_c('positiveity-indicator', {
    attrs: {
      "number": _vm.changeInAudience,
      "message": _vm.changeInAudienceMessage
    }
  }), _vm._v(" "), _c('oval-button', {
    staticClass: "revision-history-revision__goto",
    nativeOn: {
      "click": function($event) {
        return _vm.goto.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          GOTO\n        ")])] : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fe7cb28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/revisionHistory/RevisionHistory.vue
// module id = 1830
// module chunks = 0